<agr-page-detail [pageTitle]="pageTitle$ | async" (backAction)="back()">
  <app-customer-navigation></app-customer-navigation>

  <div [@routeAnimations]="routeAnimationState()">
    <router-outlet></router-outlet>
  </div>
</agr-page-detail>
